import React, { useEffect } from 'react';
import '../common/Toast.css';

export interface ToastMessage {
  id: string;
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
  duration?: number;
}

interface ToastProps {
  toast: ToastMessage | null;
  onClose: () => void;
}

export const Toast: React.FC<ToastProps> = ({ toast, onClose }) => {
  useEffect(() => {
    if (toast) {
      const timer = setTimeout(() => {
        onClose();
      }, toast.duration || 3000);

      return () => clearTimeout(timer);
    }
  }, [toast, onClose]);

  if (!toast) return null;

  return (
    <div className={`toast toast-${toast.type}`} data-testid={`toast-${toast.type}`}>
      <div className="toast-content">
        {toast.type === 'success' && <span className="toast-icon" data-testid="toast-icon-success">✓</span>}
        {toast.type === 'error' && <span className="toast-icon" data-testid="toast-icon-error">✕</span>}
        {toast.type === 'warning' && <span className="toast-icon" data-testid="toast-icon-warning">⚠</span>}
        {toast.type === 'info' && <span className="toast-icon" data-testid="toast-icon-info">ℹ</span>}
        <span className="toast-message" data-testid="toast-message">{toast.message}</span>
      </div>
      <button className="toast-close" data-testid="toast-close-btn" onClick={onClose}>×</button>
    </div>
  );
};

export default Toast;
